import { useEffect, useState } from 'react'
import { getLrrContentStatusForStandaloneViewer } from '../fetch/get-lrr-content-status-for-standalone-viewer'

/**
 * Content status for a standalone-viewed law, or null when there is nothing to say.
 *
 * Absent when the viewer was reached without a reference (a bookmark, or a link created
 * before the id was threaded through): staleness only exists relative to a citation, so
 * with no reference there is no question to ask.
 */
export function useLrrContentStatusInStandalone(referenceId: string | null): string | null {
  const [contentStatus, setContentStatus] = useState<string | null>(null)

  useEffect(() => {
    if (!referenceId) {
      setContentStatus(null)
      return
    }

    let cancelled = false
    getLrrContentStatusForStandaloneViewer(referenceId)
      .then((status) => {
        if (!cancelled) setContentStatus(status)
      })
      .catch(() => {
        // Never block the document over a badge.
        if (!cancelled) setContentStatus(null)
      })

    return () => {
      cancelled = true
    }
  }, [referenceId])

  return contentStatus
}
